"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";
import Box from "@mui/material/Box";
import dynamic from "next/dynamic";
// import { Player } from "@lottiefiles/react-lottie-player"; // or import Lottie from 'lottie-react'
// import loaderAnimation from "@/assets/loader.json"; // your Lottie JSON


const Player = dynamic(
  () =>
    import("@lottiefiles/react-lottie-player").then((mod) => mod.Player),
  { ssr: false }
);
// Shape of our loader context
interface LoaderContextType {
  isLoading: boolean;
  showLoader: () => void;
  hideLoader: () => void;
}

// Create context with default stub implementations
const LoaderContext = createContext<LoaderContextType>({
  isLoading: false,
  showLoader: () => {},
  hideLoader: () => {},
});

// Provider component that wraps your app
export function LoaderProvider({ children }: { children: ReactNode }) {
  const [isLoading, setIsLoading] = useState(false);

  const showLoader = () => {setIsLoading(true)};
  const hideLoader = () => {setIsLoading(false)};

  return (
    <LoaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>
      {children}

      {/* Full-page overlay loader */}
      {isLoading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            backdropFilter:"blur(20px)"
            // filter:"blur(20px)"
          }}
        >
          <Player
            autoplay
            loop
            src={"https://sr-cdn-1.shiprocket.in/sr-promise/images/trends_loader.json"}
            style={{ height: 200, width: 200 }}
          />
          {/* <img src="https://sr-cdn-1.shiprocket.in/sr-promise/images/trends_loader.gif"/> */}
        </Box>
      )}
    </LoaderContext.Provider>
  );
}

// Custom hook for components to access loader
export function useLoader() {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoader must be used within a LoaderProvider");
  }
  return context;
}
